import { put, takeLatest } from 'redux-saga/effects';
import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, patchRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getContactUs, successContactUs, failedContactUs, removeContactUs, updateContactUs, getDashboardData } from '../slice/contactUsSlice';
import { addProduct, getProduct, updateProduct, successProduct, removeProduct, getOneProduct, searchProductByName } from '../slice/productSlice';
import { getGallery, successGallery, removeGallery, addGallery, updateGallery, getOneGallery } from '../slice/gallerySlice';
import { getBanner, successBanner, removeBanner, addBanner, updateBanner, getOneBanner } from '../slice/bannerSlice';
import { getCustomer, successCustomer, removeCustomer, addCustomer, updateCustomer, getOneCustomer, searchByMobile } from '../slice/customerSlice';
import { addOrderListDB, getOrderListDB, getOrderDeatilsDB, successOrderListDB, failedOrderListDB, updateOrderListDB } from '../slice/orderSliceDB';
import { updateOrderAPI } from './orderAPI/orderAPI';
import { addService, getService, getOneService, updateService, removeService, successService, failedService } from '../slice/serviceSlice';


// Generator function
function* signinUser({ payload }) {
  try {
    // You can also export the axios call as a function.
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true, // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        message: 'something wrong try after sometime'
      }
    }
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getContactUsFun({ payload }) {
  try {
    const response = yield getRequest('contactus', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status == 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}


function* getProductFun() {
  try {
    const response = yield getRequest('products');
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOneProductFun({ payload }) {
  try {
    let response;
    try {
      response = yield getRequest(`products/one/${payload}`);
    } catch {
      response = yield getRequest(`products/${payload}`);
    }
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('contactus', payload);
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateContactUsFun({ payload }) {
  try {
    const response = yield patchRequest(`contactus/${payload?.id}`, payload?.data || {});
    if (response?.status == 200) {
      toast(response?.data?.message || 'Contact updated successfully!');
      const listResponse = yield getRequest('contactus');
      if (listResponse?.status == 200) {
        yield put(successContactUs(listResponse?.data));
      } else {
        yield put(failedContactUs(listResponse));
      }
    } else {
      yield put(failedContactUs(response));
      toast(response?.data?.message || 'Failed to update contact');
    }
  } catch (error) {
    yield put(failedContactUs(error));
    toast(error?.response?.data?.message || error?.message || 'Failed to update contact');
  }
}

function* removeProductFun({ payload }) {
  try {
    const response = yield deleteRequest(`products/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('products', payload);
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* addProductFun({ payload }) {
  try {
    const response = yield postRequest(`products`, payload);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* searchProductByNameFun({ payload }) {
  try {
    const response = yield getRequest(`products/search?product=${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateProductFun({ payload }) {
  try {
    const response = yield patchRequest(`products/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
      toast.success('Product updated successfully!');
    } else {
      yield put(failedContactUs(response));
      toast.error(response?.data?.message || response?.data || 'Failed to update product');
    }
  } catch (error) {
    console.error('Update product error:', error)
    const msg = error?.response?.data?.message || error?.response?.data || error?.message || 'Failed to update product';
    toast.error(msg)
    yield put(failedContactUs(error))
  }
}

//Gallery Functions 
function* getGalleryFun() {
  try {
    const response = yield getRequest('gallery'); // no second argument

    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`galleries/one/${payload}`);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`galleries/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('galleries', payload);
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest(`galleries`, payload);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`galleries/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}



//Banner Start
function* getBannerFun() {
  try {
    const response = yield getRequest('banner');
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOneBannerFun({ payload }) {
  try {
    const response = yield getRequest(`banner/one/${payload}`);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* removeBannerFun({ payload }) {
  try {
    const response = yield deleteRequest(`banner/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('banner', payload);
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* addBannerFun({ payload }) {
  try {
    const response = yield postRequest(`banner`, payload);
    if (response?.status == 200 || response?.status == 201) {
      const listResponse = yield getRequest('banner');
      if (listResponse?.status == 200) {
        yield put(successBanner(listResponse?.data));
      } else {
        yield put(successBanner(response?.data));
      }
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateBannerFun({ payload }) {
  try {
    const response = yield patchRequest(`banner/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successBanner(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

//Banner End 

// Services Start
function* getServiceFun() {
  try {
    const response = yield getRequest('services');
    if (response?.status == 200) {
      yield put(successService(response?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOneServiceFun({ payload }) {
  try {
    const response = yield getRequest(`services/one/${payload}`);
    if (response?.status == 200) {
      yield put(successService(response?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* addServiceFun({ payload }) {
  try {
    const response = yield postRequest(`services`, payload);
    if (response?.status == 200) {
      yield put(successService(response?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateServiceFun({ payload }) {
  try {
    const response = yield patchRequest(`services/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successService(response?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* removeServiceFun({ payload }) {
  try {
    const response = yield deleteRequest(`services/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('services', payload);
      yield put(successService(response?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

// Services End




// customer start
function* addCustomerFun({ payload }) {
  try {
    const response = yield postRequest(`customer`, payload);
    if (response?.status == 200 || response?.status == 201) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedCustomer(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}


export function* getCustomerFun() {
  try {
    const response = yield getRequest('customers'); // Your API endpoint
    if (response?.status === 200) {
      yield put(successCustomer(response.data));
    } else {
      yield put(failedCustomer(response.message || "Failed to fetch customers"));
    }
  } catch (error) {
    console.error('Saga error:', error);
    toast.error(error?.response?.data?.message || "Error fetching customers");
    yield put(failedCustomer(error?.response?.data?.message || "Fetch failed"));
  }
}

function* removeCustomerFun({ payload }) {
  try {
    const response = yield deleteRequest(`customers/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('customers', payload);
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedCustomer(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOneCustomerFun({ payload }) {
  try {
    const response = yield getRequest(`customers/one/${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedCustomer(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* updateCustomerFun({ payload }) {
  try {
    const response = yield patchRequest(`customers/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedCustomer(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* searchByMobileFun({ payload }) {
  try {
    const response = yield getRequest(`customers/search?name=${payload}`);
    if (response?.status == 200) {
      yield put(successCustomer(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

// customer end

// order list DB start
function* addOrderListDBFun({ payload }) {
  try {
    const response = yield postRequest(`order`, payload);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOrderListDBFun() {
  try {
    const response = yield getRequest('order');
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}

function* getOrderDeatilsDBFun({payload}) {
  try {
    const response = yield getRequest(`order/order_details/${payload}`);
    if (response?.status == 200) {
      yield put(successOrderListDB(response?.data));
    } else {
      yield put(failedOrderListDB(response));
    }
  } catch (error) {
    console.log(error)
    toast.error(error?.response?.data?.message || error?.message || 'Something went wrong')
  }
}




// Generator function
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);

  // contact us
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(getDashboardData, getDashboardDataFun);
  yield takeLatest(removeContactUs, removeContactUsFun);
  yield takeLatest(updateContactUs, updateContactUsFun);


  yield takeLatest(addProduct, addProductFun);
  yield takeLatest(getProduct, getProductFun);
  yield takeLatest(getOneProduct, getOneProductFun);
  yield takeLatest(searchProductByName, searchProductByNameFun);
  yield takeLatest(removeProduct, removeProductFun);
  yield takeLatest(updateProduct, updateProductFun);

  //gallery
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(getGallery, getGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);

  //Banner
  yield takeLatest(addBanner, addBannerFun);
  yield takeLatest(getBanner, getBannerFun);
  yield takeLatest(removeBanner, removeBannerFun);
  yield takeLatest(getOneBanner, getOneBannerFun);
  yield takeLatest(updateBanner, updateBannerFun);

  // Services
  yield takeLatest(addService, addServiceFun);
  yield takeLatest(getService, getServiceFun);
  yield takeLatest(removeService, removeServiceFun);
  yield takeLatest(getOneService, getOneServiceFun);
  yield takeLatest(updateService, updateServiceFun);

  //Customer
  yield takeLatest(addCustomer, addCustomerFun);
  yield takeLatest(getCustomer, getCustomerFun);
  yield takeLatest(removeCustomer, removeCustomerFun);
  yield takeLatest(getOneCustomer, getOneCustomerFun);
  yield takeLatest(updateCustomer, updateCustomerFun);
  yield takeLatest(searchByMobile, searchByMobileFun);


  // order DB
  yield takeLatest(addOrderListDB, addOrderListDBFun);
  yield takeLatest(getOrderListDB, getOrderListDBFun);
  yield takeLatest(getOrderDeatilsDB, getOrderDeatilsDBFun);
  yield takeLatest(updateOrderListDB, updateOrderAPI);

  

}
